(function () {
  'use strict';
  if (window.BFCarousels) return;
  var instances = new Map();
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  function init(root) {
    if (instances.has(root)) return;
    var slides = Array.from(root.querySelectorAll('[data-bf-slide]'));
    var dots = Array.from(root.querySelectorAll('[data-bf-dot]'));
    if (!slides.length) return;
    var stage = root.querySelector('[class$="__stage"]');
    var pause = root.querySelector('[data-bf-pause]');
    var autoplay = root.getAttribute('data-bf-autoplay') !== 'off';
    var interval = Math.max(2, Number(root.dataset.bfInterval) || 6) * 1000;
    var index = Math.min(slides.length - 1, Number(root.dataset.bfInitial) || 0);
    var elapsed = 0, last = 0, frame = 0, inView = false, hovering = false, focused = false, paused = false;
    var listeners = [], pointer = null;
    function listen(target, event, fn, options) {
      if (target.addEventListener) { target.addEventListener(event, fn, options); listeners.push(function () { target.removeEventListener(event, fn, options); }); }
      else if (event === 'change' && target.addListener) { target.addListener(fn); listeners.push(function () { target.removeListener(fn); }); }
    }
    function progress(ratio) {
      dots.forEach(function (dot, i) { var fill = dot.querySelector('span'); if (fill) fill.style.transform = 'scaleX(' + (i < index ? 1 : i === index ? ratio : 0) + ')'; });
    }
    function render(next, keyboard) {
      index = (next + slides.length) % slides.length;
      elapsed = 0; last = 0;
      root.dataset.bfActive = String(index);
      root.classList.toggle('bf-carousel-instant', !!keyboard);
      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === index);
        slide.classList.toggle('is-prev', i === (index + slides.length - 1) % slides.length);
        slide.classList.toggle('is-next', i === (index + 1) % slides.length);
        slide.setAttribute('aria-hidden', String(i !== index));
      });
      dots.forEach(function (dot, i) { if (i === index) dot.setAttribute('aria-current', 'true'); else dot.removeAttribute('aria-current'); });
      progress(0);
    }
    function runnable() { return autoplay && inView && !document.hidden && !hovering && !focused && !paused && !reduced.matches && slides.length > 1; }
    function tick(now) {
      frame = 0;
      if (!runnable()) { last = 0; return; }
      if (last) elapsed += now - last;
      last = now;
      if (elapsed >= interval) { render(index + 1); last = now; }
      progress(elapsed / interval);
      frame = requestAnimationFrame(tick);
    }
    function schedule() {
      if (!runnable()) { if (frame) cancelAnimationFrame(frame); frame = 0; last = 0; }
      else if (!frame) frame = requestAnimationFrame(tick);
    }
    listen(root.querySelector('[data-bf-prev]'), 'click', function (e) { render(index - 1, e.detail === 0); schedule(); });
    listen(root.querySelector('[data-bf-next]'), 'click', function (e) { render(index + 1, e.detail === 0); schedule(); });
    dots.forEach(function (dot, i) { listen(dot, 'click', function (e) { render(i, e.detail === 0); schedule(); }); });
    if (pause) listen(pause, 'click', function () { paused = !paused; pause.textContent = paused ? '▶' : 'Ⅱ'; pause.setAttribute('aria-label', (paused ? 'Resume' : 'Pause') + ' ' + (root.dataset.bfCarousel === 'story' ? 'stories' : 'benefits') + ' autoplay'); pause.setAttribute('aria-pressed', String(paused)); schedule(); });
    listen(root, 'pointerenter', function (e) { if (e.pointerType !== 'touch') { hovering = true; schedule(); } });
    listen(root, 'pointerleave', function () { hovering = false; schedule(); });
    listen(root, 'focusin', function (e) { focused = e.target.matches(':focus-visible'); schedule(); });
    listen(root, 'focusout', function (e) { focused = !!e.relatedTarget && root.contains(e.relatedTarget) && e.relatedTarget.matches(':focus-visible'); schedule(); });
    listen(stage, 'keydown', function (e) { var next = e.key === 'ArrowRight' ? index + 1 : e.key === 'ArrowLeft' ? index - 1 : e.key === 'Home' ? 0 : e.key === 'End' ? slides.length - 1 : null; if (next !== null) { e.preventDefault(); render(next, true); schedule(); } });
    listen(stage, 'pointerdown', function (e) { if (e.pointerType !== 'touch' || e.target.closest('button')) return; pointer = { x: e.clientX, y: e.clientY, id: e.pointerId }; stage.setPointerCapture(e.pointerId); });
    listen(stage, 'pointerup', function (e) { if (!pointer || e.pointerId !== pointer.id) return; var dx = e.clientX - pointer.x, dy = e.clientY - pointer.y; if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) render(index + (dx < 0 ? 1 : -1)); pointer = null; schedule(); });
    listen(stage, 'pointercancel', function () { pointer = null; });
    listen(document, 'visibilitychange', schedule);
    listen(reduced, 'change', schedule);
    listen(document, 'shopify:block:select', function (e) { var i = slides.findIndex(function (slide) { return slide === e.target || slide.contains(e.target); }); if (i >= 0) { paused = true; render(i, true); schedule(); } });
    var observer = null;
    if (window.IntersectionObserver) {
      observer = new window.IntersectionObserver(function (entries) { inView = entries[0].isIntersecting; schedule(); }, { threshold: .15 });
      observer.observe(root);
    } else { inView = true; schedule(); }
    render(index);
    instances.set(root, function () { if (frame) cancelAnimationFrame(frame); if (observer) observer.disconnect(); listeners.forEach(function (remove) { remove(); }); instances.delete(root); });
  }
  function initialize(scope) { scope.querySelectorAll('[data-bf-carousel]').forEach(init); }
  window.BFCarousels = { initialize: initialize };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initialize(document); }); else initialize(document);
  document.addEventListener('shopify:section:load', function (e) { initialize(e.target); });
  document.addEventListener('shopify:section:unload', function (e) { Array.from(instances).forEach(function (entry) { if (e.target.contains(entry[0])) entry[1](); }); });
})();
